import Navf from './Navf.js'

export default function Footer() {
    return(
        <footer class="Footer">
            <div>
                <div>
                    <Navf/>
                     <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lobortis purus nec libero ultricies, et ultricies arcu euismod. Donec scelerisque consectetur dapibus.
Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lobortis purus nec libero ultricies, et ultricies arcu euismod. Donec scelerisque consectetur dapibus.
                     </p>
                </div>
                <img src={require("../../Icon.png")} alt="icon" width="270" height="155"/>
            </div>
        </footer>
    )
}